const styles = ({ spacing }) => ({
  '& ul': {
    '& li': {
      '& button': {
        '&:hover': {
          textDecoration: 'underline',
        },
        textDecoration: 'none',
      },
      display: 'flex',
      paddingBottom: 20,
    },
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },
  padding: spacing.sm,
  paddingBottom: 0,
  paddingRight: 0,
});

export default styles;
